/**
 * 错误处理
 */
import { cookie } from "@/utils";
import { Pay, GiftRank, BookCatalog } from "@/views/index.js";

import { SendSuccess, SendError } from "@/components/dialog";

import {
  // Chapter_Pay,
  Chapter_Buy,
  Book_Pay,
  Book_Buy
} from "../components/dialog";

/**
 * 送礼pop错误
 */
const PopErrTypeMap = new Map([
  [
    "help",
    (vue, type) => {
      vue.toHelp(type.value);
    }
  ],
  [
    "pay",
    (vue, type, data, isReader) => {
      cookie.setCookie(
        "N_vipURL",
        isReader
          ? `${location.origin}/reader/${data.bid}/${data.id}`
          : `${location.origin}/detail/${data.bid}`
      );
      vue.$router.push({
        name: Pay.name
      });
    }
  ],
  [
    "gift",
    (vue, type, data) => {
      vue.$router.push({
        name: GiftRank.name,
        params: {
          bid: data.bid
        }
      });
    }
  ],
  [
    "account",
    vue => {
      vue.$router.push("/accountinfo/accountlevel");
    }
  ],
  [
    "default",
    () => {
      /* eslint-disable */
      console.log("礼物操作报错");
    }
  ]
]);

/**
 * 送票送礼之后的弹窗反馈
 */
const AfterSendHanlderMap = new Map([
  [
    1,
    (vue, data) => {
      setTimeout(() => {
        vue.$toast.clear();
        SendSuccess(data)
          .then(r => {
            console.log("继续", r);
            vue.sendContinue(r);
          })
          .catch(e => console.log(e));
      }, 600);
    }
  ],
  [
    0,
    (vue, data) => {
      setTimeout(() => {
        vue.$toast.clear();
        SendError(data)
          .then(r => {
            console.log("继续", r);
            vue.sendContinue(r);
          })
          .catch(e => {
            e.action && vue.$router.push({ name: Pay.name });
          });
      }, 600);
    }
  ],
  [
    "default",
    () => {
      /* eslint-disable */
      console.log("取消操作");
    }
  ]
]);

export const PopupErr = {
  methods: {
    giftErr(e, data, isReader = false) {
      let errCodeHandle =
        PopErrTypeMap.get(e.type) || PopErrTypeMap.get("default");
      errCodeHandle.call(this, this, e, data, isReader);
    },
    handlerAfterSend(status, data) {
      this.$toast({
        type: "loading",
        message: "请稍等...",
        forbidClick: true,
        duration: 0
      });
      let handler =
        AfterSendHanlderMap.get(status) || AfterSendHanlderMap.get("default");
      handler.call(this, this, data);
    },
    sendContinue(r) {
      setTimeout(() => {
        this.$toast.clear();
        r.action && this.showPopup(r.index);
      }, 600);
    }
  }
};

/**
 * 阅读器错误
 */
const readerErrCodeMap = new Map([
  [
    10016,
    (data, vue) => {
      Chapter_Buy(data)
        .then(() => {
          // TODO 单章购买
          vue.readerBuyHandle(1, data);
        })
        .catch(e => {
          vue.catchHandle(e);
        });
    }
  ],
  [
    10017,
    (data, vue) => {
      Book_Buy(data)
        .then(() => {
          // TODO 单本购买
          vue.readerBuyHandle(2, data);
        })
        .catch(e => {
          vue.catchHandle(e);
        });
    }
  ],
  [
    10015,
    (data, vue) => {
      // TODO 单章购买 余额不足
      vue.$router.push({
        name: Pay.name,
        query: Object.assign(data, {
          code: 10015
        })
      });
    }
  ],
  [
    10014,
    (data, vue) => {
      Book_Pay(data)
        .then(() => {
          // TODO 单本购买 余额不足
          vue.$router.push({
            name: Pay.name,
            query: Object.assign(data, {
              code: 10014
            })
          });
        })
        .catch(e => {
          vue.catchHandle(e);
        });
    }
  ],
  [
    10012,
    data => {
      // TODO 强关
      location.replace(data.src);
    }
  ],
  [
    20002,
    (data, vue) => {
      const router = vue.$route;
      vue.$router.push({
        name: BookCatalog.name,
        params: { bid: router.params.bid },
        query: {
          cid: data.cid,
          order: data.sequence
        }
      });
    }
  ],
  [
    10023,
    data => {
      // 链接强关
      location.replace(data.src);
    }
  ],
  [
    "default",
    data => {
      /* eslint-disable */
      console.log("其他错误", data);
    }
  ]
]);

export const ReaderErr = {
  methods: {
    readerErrHandle(code, data) {
      // * 根据章节错误状态码显示不同的操作
      console.log(code, data);
      let errCodeHandle =
        readerErrCodeMap.get(code) || readerErrCodeMap.get("default");
      errCodeHandle.call(this, data, this);
    },
    setRedirect(data) {
      // * 存入页面地址到cookie中
      cookie.setCookie(
        "N_vipURL",
        `${location.origin}/reader/${data.bid}/${data.cid}`
      );
    },
    cancelBuy() {
      // * 取消购买
      if (!this.chapter.state) {
        if (!this.init) {
          this.routerName ? this.$router.back() : this.$router.go(-2);
          // this.routerName || this.$router.go(-2);
        }
      }
    },
    catchHandle(e) {
      if (e && e === "account") this.toAccount();
      else this.cancelBuy();
    },
    toAccount() {
      this.$router.push({
        path: "/accountinfo/accountlevel"
      });
    }
  }
};
